import * as validators from '../_utils/validators.js';
import {apiFetch} from "../_utils/apiInterceptor.js";

const backendUrl = process.env.REACT_APP_BACKEND_URL;
const QUERY_BASE_URL = `${backendUrl}/api/v1/queries`;
const CHAT_BASE_URL = `${backendUrl}/api/v1/chats`;

export const submitQuery = async (formData) => {
  const {fullName, emailAddress, mobileNumber, subject, message} = formData;

  if(validators.isEmpty(fullName) || validators.isShorterThan(fullName, 5) || validators.isLongerThan(fullName, 50)){
    throw new Error(
      'Validation Error: Invalid full name.'
    );
  }
  
  if(validators.isEmpty(emailAddress) || !validators.isValidEmail(emailAddress)){
    throw new Error(
      'Validation Error: Invalid email address.'
    );
  }

  if(validators.isEmpty(mobileNumber) || !validators.isValidMobileNumber(mobileNumber)){
    throw new Error(
      'Validation Error: Mobile number is not valid. accepted format (260XXXXXXXXX).'
    );
  }
  
  if(validators.isEmpty(subject) || validators.isShorterThan(subject, 5) || validators.isLongerThan(subject, 50)){
    throw new Error(
      'Validation Error: Invalid query subject.'
    );
  }
  
  if(validators.isEmpty(message) || validators.isShorterThan(message, 10) || validators.isLongerThan(message, 255)){
    throw new Error(
      'Validation Error: Invalid query message.'
    );
  }
  
    return await apiFetch(
      `${QUERY_BASE_URL}/`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(formData),
    });
};  

export const fetchQueries = async () => {
  return await apiFetch(
    `${QUERY_BASE_URL}/`, {
    method: 'GET'
  });
}

export const submitChat = async (queryId, chat) => {
  return await apiFetch(
    `${CHAT_BASE_URL}/?queryId=${queryId}`, {
    method: 'POST',
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({message:chat}),
  });
};  

export const fetchChats = async (queryId) => {
  return await apiFetch(
    `${CHAT_BASE_URL}/?queryId=${queryId}`, {
    method: 'GET'
  });
}

export const deleteChat = async (chatId) => {
  return await apiFetch(
    `${CHAT_BASE_URL}/?chatId=${chatId}`, {
    method: 'DELETE',
    headers: {
      "Content-Type": "application/json"
    }
  });
};  
